import { icons } from "../Helpers/ImportIcons";

const WeatherIcon = ({ weather }) => {
  return (
    <img
      src={icons[weather.weather[0].icon]}
      alt={weather.weather[0].description}
      className=""
      height={40}
    />
  );
};

export default WeatherIcon;
